import React, {useEffect, useState} from "react";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import {useAuthHeader} from "react-auth-kit";
import {useColorModeValue} from "@chakra-ui/react";

function RateChart({getAction}) {
    const textColor = useColorModeValue("#414040", "#f6f5f5");
    const token = useAuthHeader();
    const [action, setAction] = useState(false)
    const [getRate, setRate] = useState([])

    useEffect(() => {
        setAction(getAction)
    },[getAction])

    useEffect(() => {
        if (action){
            let active = true
            const getResult = async () => {
                if (active) {
                    const result = await fetchDataRate(token());

                    let fourteenData = getArrFourteen()

                    let fourteenDataAddValue = {};
                    for (const key of fourteenData) {
                        fourteenDataAddValue[key] = 0;
                    }
                    let p = { ...fourteenDataAddValue, ...result }

                    let rate = []
                    for (const key in p) {
                        rate.push(Number(p[key]))
                    }

                    setRate([110.2, 110.2, 100.1, 98.3, 98.3, 91.3, 98.3, 100.3, 98.3, 98.3, 100.1, 91.3, 98.3, 110.2, 99.1])

                    return () => {
                        active = false;
                    };
                }
            }
            getResult().then();
            return () => {
                active = false;
            };
        }
    },[action])

    const lineChartData = [
        {
            name: "RUB",
            data: getRate,
        },
    ];

    const lineChartOptions = {
        chart: {
            toolbar: {
                show: false,
            },
        },
        tooltip: {
            theme: "dark",
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
        },
        xaxis: {
            type: "datetime",
            categories: getArrFourteen(),
            labels: {
                style: {
                    colors: textColor,
                    fontSize: "12px",
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    color: textColor,
                    fontSize: "12px",
                },
            },
        },
        legend: {
            show: false,
        },
        grid: {
            strokeDashArray: 5,
        },
        fill: {
            type: "gradient",
            gradient: {
                shade: "light",
                type: "vertical",
                shadeIntensity: 0.5,
                gradientToColors: undefined,
                inverseColors: true,
                opacityFrom: 0.8,
                opacityTo: 0,
                stops: [],
            },
            colors: ["#4FD1C5", "#548cee"],
        },
        colors: ["#4FD1C5", "#548cee"],
    };

    return (
        <ReactApexChart
            options={lineChartOptions}
            series={lineChartData}
            type="area"
            width="100%"
            height="100%"
        />
    );
}

async function fetchDataRate(token) {
    const response = await axios.get(`/api/v1/fx_rate`,
        {headers: {Authorization: token}})
    const newData = await response.data;
    let d = []
    let am = []
    let result = {};
    let data = Object.values(newData)
    data.forEach(id => {
        if (id.currency_from === 'RUB') {
            d.push(id.active_from.substring(0,10))
            am.push(id.rate)
        }
    })

    for (let i = 0; i < d.length; ++i)
    {
        result[d[i]] = am[i]
    }

    return result
}

function getFourteen() {
    let nowData = new Date()
    nowData.setDate(nowData.getDate() - 14);
    const yyyy = nowData.getFullYear();
    let mm = nowData.getMonth() + 1; // Months start at 0!
    let dd = nowData.getDate();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return yyyy + '-' + mm +  '-' + dd + 'T' + '00:00:00';
}

function getArrFourteen() {
    let arr = [];
    for (let i = 14; i >= 0; i--) {
        let nowData = new Date()
        nowData.setDate(nowData.getDate() - i);
        let yyyy = nowData.getFullYear();
        let mm = nowData.getMonth() + 1;
        let dd = nowData.getDate();
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        arr.push(yyyy + '-' + mm +  '-' + dd)
    }
    return arr
}

export default RateChart;
